import { motion } from "framer-motion";
import { ETSY_SHOP_URL } from "@/data/products";

/**
 * ShopBanner — clean full-width "Shop All" CTA. Massive type, single button.
 */
export default function ShopBanner() {
  return (
    <section
      className="relative bg-[#1a1412] py-32 md:py-48 border-t border-[#362b28] overflow-hidden"
      data-testid="shop-banner-section"
    >
      <div className="absolute inset-0 pointer-events-none opacity-25">
        <img
          src="/brand/founder-baobabs.webp"
          alt=""
          aria-hidden
          className="w-full h-full object-cover object-[50%_30%]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a1412] via-[#1a1412]/85 to-[#1a1412]/95" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="eyebrow mb-8"
        >
          The Full Collection
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
          className="font-serif text-[56px] md:text-[96px] lg:text-[128px] leading-[0.95] tracking-[-0.02em] text-[#e8dcc4]"
        >
          Wear <em className="italic text-[#c28b46]">the truth.</em>
        </motion.h2>

        <motion.a
          href={ETSY_SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="btn-terra mt-12 inline-flex"
          data-testid="shop-banner-cta"
        >
          Shop The Full Store on Etsy
          <span aria-hidden>→</span>
        </motion.a>
      </div>
    </section>
  );
}
